import React from 'react';
import PropTypes from 'prop-types';
import waveImage from '../Order/waves.svg';
import './SwitchedToOpenTerm.scss';

const title = 'Just a heads up';

const bgStyle = {
  backgroundImage: `url(${waveImage})`
};

const SwitchedToOpenTerm = props => !props.hasSwitchedToOpenTerm ? null :
  (
    <div className="container">
      <div className="row payment-fyi">
        <div id="fyi-image-cotnainer" className="col-lg-2 centre">
          <div className="payment-fyi-image-background-container">
            <div className="payment-fyi-image-background" style={bgStyle} />
            <div className="payment-fyi-image"><span>FYI</span></div>
          </div>
        </div>
        <div className="col-lg-10 payment-fyi-message">
          <div className="payment-fyi-message-title">{title}</div>
          <div>Because you&apos;ve opted to go for a No Pesky Term contract an upfront payment of $49 Connection Fee {!props.isByoModemSelected ? 'and $150 modem charge' : ''} will apply</div>
        </div>
      </div>
    </div>
  );

SwitchedToOpenTerm.propTypes = {
  hasSwitchedToOpenTerm: PropTypes.bool,
  isByoModemSelected: PropTypes.bool
};

export default SwitchedToOpenTerm;



/** WEBPACK FOOTER **
 ** ./src/components/payment/SwitchedToOpenTerm/SwitchedToOpenTerm.js
 **/